
import { Options, mixins } from "vue-class-component";
import PosService from "../../service/PosService.js";
import ProfilerService from "../../service/ProfilerService.js";
import ChartService from "../../service/ChartService.js";
import Toaster from "../../helpers/Toaster";
import AutoComplete from "primevue/autocomplete";
import SearchFilter from "../../components/SearchFilter.vue";
import PosPreviewReceipt from "../../components/PosPreviewReceipt.vue";
import PaymentScreen from "../../components/PaymentScreen.vue";
import { useStore,ActionTypes } from "../../store";
import UtilityOptions from "../../mixins/UtilityOptions";

interface PaymentListType {
    paymentType: string;
    accountNo: string;
    terminalId: string;
    authCode: string;
    transId: string;
    transStatus: string;
    transType: string;
    transDate: string;
    transTime: string;
    transAmount: number;
    transTotalAmount: number;
    transRef: string;
    entryMode: string;
    hostResponse: string;
    giftCardRef: string;
    cardBalance: string;
    tendered: number;
    change: number;
    roundOff: number;
    bankID: number;
}

@Options({
    title: 'Transactions',
    components: {
        PaymentScreen,
        AutoComplete,
        SearchFilter,
        PosPreviewReceipt
    }
})
export default class TransactionReceipt extends mixins(UtilityOptions) {
    private lists = [];

    private selectedReceiptData = {
        paymentTransactions: []
    };
    private supplierFilter = true;
    private profilerList = [];
    private accountHeadList = [];
    private totalAmountStatement = "Total Amount Received";
    private statement = "";
    private menuBar = false;
    private paymentDialog = false;
    private dialogTitle = "";
    private toast;
    private goToFirstLink = 0;
    private receiptNO = "";
    private previewHeading = "";
    private receiptID = 0;
    private receiptService;
    private profilerService;
    private chartService;
    private previewTransactionDialog = false;
    private previewPosReceipt = false;
    private productDialog = false;
    private filterDialog = false;
    private submitted = false;
    private statusDialog = false;
    private checkPagination = true;
    private totalRecords = 0;
    private totalBalanceReceipt = 0;
    private limit = 0;
    private home = { icon: "pi pi-home", to: "/" };
    private items = [{ label: "Transactions", to: "/process/transactions" }];
    private scanBuffer= '';
    private scannedText= '';
    private popupVisible= false;
    private totalAmountAllRecords = 0;
    private totalBalanceAllRecords = 0;
    private latency = 0;
    private cashPaymentOption = true;
    private cardPaymentOption = true;
    private payLaterOption = true;
    private chequePaymentOption = false;
    private selectedDateFilter = {'key':'This Month', 'value':'this_month'};
    private scenario = '';
    private counterEntry = [
        {
            accountID: 0,
            accountHead: "",
            amount: 0,
            type: "Debit"
        }
    ];
    private supplierCreditAmount = 0;
    private paySupplierCredit = false;

    private receiptTypes = [
        { key: "Pay Later Receipts", value: "PayLater" },
        { key: "Sales Receipt", value: "INE" },
        { key: "Refund Receipt", value: "RFD" },
        // { key: "Transfer Stocks", value: "TRN" },
        // { key: "Arrived Stocks", value: "ASR" },
        { key: "Purchase Receipt", value: "PUR" },
        { key: "Purchase Return", value: "RPU" }
    ];

    private itemFilter = {
        keyword: "",
        filterType: "this_month",
        storeID: 0,
        date1: "",
        date2: "",
        type: "INE",
        customerName: 'All',
        UserName: 'All',
        customerID: 0,
        userID: 0,
        supplierID: 0
    };

    private paymentList: PaymentListType[] = [];

    private item = {
        id: 0,
        profileID: 0,
        selectedProfile: "",
        type: "",
        status: ""
        
    };

    //CALLING WHEN PAGINATION BUTTON CLICKS
    onPage(event) {

    //console.log("Paginaton button clicked function");
    ////console.log("Paginaton button clicked",event);
        this.loadList(event.first);
    }

    //DEFAULT METHOD OF TYPE SCRIPT
    created() {
        this.receiptService = new PosService();
        this.profilerService = new ProfilerService();
        this.chartService = new ChartService();
        this.toast = new Toaster();
    }

    //CALLNING AFTER CONSTRUCTOR GET CALLED
    mounted() {
        if(this.$route.query.additionalFilter){
            this.itemFilter.type = '' + this.$route.query.additionalFilter;
            this.selectedDateFilter = {'key':'All', 'value':'all'};
            this.itemFilter.filterType = 'all';
            this.scenario = 'PayLater';
        }
        if(this.$route.query.supplier_id){
            this.itemFilter.supplierID = Number(this.$route.query.supplier_id);
            this.items.unshift({ label: "Supplier Credits", to: "/home/suppliers" });
        }
        if(this.$route.query.type){
            this.itemFilter.type = ''+this.$route.query.type;
        }
        this.loadList(0);
        // Add event listener for keypress
        window.addEventListener('keypress', this.handleKeypress);
    }
    
    beforeUnmount() {
    // Remove event listener
    window.removeEventListener('keypress', this.handleKeypress);
    }

    handleKeypress(event) {
      // Check for "Enter" key to detect the end of scanning
      if (event.key === 'Enter') {
        this.loadSearchData();

        // this.openMenu(item);
        // this.openPaymentScreen();
        // this.openPaymentScreen();

        // this.scannedText = this.scanBuffer;
        // this.scanBuffer = ''; // Clear buffer
        //this.popupVisible = true; // Show popup

        // Search for matching receipt number
        // const matchedData = this.tableData.find(
        //   row => row.receiptNumber === this.scannedText
        // );
        // let matchFound = false;
        // let index = 0;
        // for (const item of this.lists as any[]) {
            
        //     if (item.receipt_no === this.scannedText) {
        //         let balance = this.calculateBalance(item.total_bill, item.receipt_balance);
        //         if(balance > 0){
        //         }else{
        //             this.toast.showError("The receipt has already been paid");
        //         }
        //         break;
        //     }else if(index===this.lists.length-1){
        //         this.toast.showError("Receipt is not found");
        //     }
        //     index++;
            
        // }
       
      } else {
        // Accumulate characters in the buffer
        this.scanBuffer += event.key;
      }
    } 

    cleanSearchData() {
        this.submitted = true;
        this.itemFilter.keyword = '';
        this.goToFirstLink = 0;
        this.loadList(0);
    }
    
    closePopup() {
      this.popupVisible = false;
    }


    openFilterDialog() {
        this.dialogTitle = "Filter Receipt";
        this.filterDialog = true;
    }

    //FETCH THE DATA FROM SERVER
    loadList(page) {
        this.receiptService
            .transactionList(this.itemFilter, page)
            .then(data => {
                this.lists = data.records;
                this.totalRecords = data.totalRecords;
                this.limit = data.limit;
                this.statement = data.statement;
                this.calculateTotalAmount(); 
                this.calculateTotalBalance();
            });
    }

    loadSearchData() {
        this.submitted = true;
        if (this.itemFilter.keyword) {
            this.goToFirstLink = 0;
            this.loadList(this.goToFirstLink);
        }
    }

    updateFilterStatus(obj) {
        this.scenario = '';
        if (obj != null && obj.loading == "Yes") {
            this.itemFilter.filterType = obj.filterName.value;
            this.itemFilter.storeID = obj.storeID.id;
            this.itemFilter.date1 = obj.date1;
            this.itemFilter.date2 = obj.date2;
            this.itemFilter.keyword = "";
            this.itemFilter.customerName = obj.customerName;
            this.itemFilter.UserName = obj.userName;
            this.itemFilter.customerID = obj.customerID;
            this.itemFilter.userID = obj.userID;
            this.itemFilter.supplierID = obj.supplierID;
            
            this.goToFirstLink = 0;
            this.loadList(this.goToFirstLink);
        }
        this.filterDialog = false;
        //////console.log("itemfilter ", this.itemFilter);
        //
    }

    calculateBalance(totalBill, receiptBalance) {
        let totalAmount = 0;
        receiptBalance.forEach(e => {
            totalAmount = totalAmount + Number(e.trans_total_amount);
        });
        return Number((totalBill) - totalAmount);
    }

    openTransactionDialog() {
        this.previewTransactionDialog = true;
        this.menuBar = false;
    }

    openPaymentScreen() {
        this.paymentDialog = true;
        this.menuBar = false;
        this.dialogTitle = "Receive Or Pay Receipt Dues";

        if (Number(this.totalBalanceReceipt) > 0) {
            this.paymentDialog = true;
            this.store.dispatch(
                ActionTypes.TOTAL_BILL,
                Number(this.formatAmount(this.totalBalanceReceipt))
            );
        } else {
            this.toast.showError(
                "Receipt balance is not valid to proceed next"
            );
        }
    }

    openMenu(data) {
        this.chequePaymentOption = (data.type == 'PUR') ? true : false;
        this.menuBar = true;
        this.selectedReceiptData.paymentTransactions = this.camelizeKeys(
            data.receipt_balance
        );
        this.item.type = data.type;
        this.item.profileID = data.profile_id;
        this.item.id = data.id;
        this.item.status = data.status;
        this.item.selectedProfile = data.profile_name.profileName;
        // this.paymentList = data.payment_transactions;
        this.totalBalanceReceipt = this.calculateBalance(
            data.total_bill,
            data.receipt_balance
        );
        
        // check supplier has credits
        if(data.supplier && data.supplier.supplier_payable > 0){// - data.supplier.supplier_receivable 
            this.supplierCreditAmount = data.supplier.supplier_payable;
            this.paySupplierCredit = true;
            
        } else {
            this.supplierCreditAmount = 0;
            this.paySupplierCredit = false;
        }
      
        ////console.log("recipt date",  this.receiptDate);
        this.calculateDaysPassed(data.receipt_date);
        ////console.log("delay",  this.calculateDaysPassed(this.receiptDate));
    }

    calculateDaysPassed(dateString) {
      // Convert string to Date object
      const givenDate = new Date(dateString);
      const today = new Date();

      // Ensure the values are treated as numbers using `.getTime()`
      const differenceInTime = today.getTime() - givenDate.getTime();

      // Convert milliseconds to days
      const differenceInDays = Math.floor(differenceInTime / (1000 * 60 * 60 * 24));

      this.latency = differenceInDays;
    }
    
    

    closePaymentScreen() {
        this.paymentDialog = false;
        this.latency = 0;
    }

    getProceededPayments(paymentList) {
        this.paymentList = paymentList;

        this.setAccountingEntries();

        this.receiptService
            .savePayment(this.item, this.paymentList, this.counterEntry)
            .then(res => {
                if (res.alert == "info") {
                    if(this.item.type == "INE"){
                        this.printReceipt();
                    }
                    this.loadList(this.goToFirstLink);
                    this.clearAll();
                }

                this.toast.handleResponse(res);
            });

        this.paymentDialog = false;
        this.submitted = false;
    }

    stockLeft() {
        this.receiptService.stockLeft(this.item).then(res => {
            if (res.alert == "info") {
                this.loadList(this.goToFirstLink);
                this.clearAll();
            }

            this.toast.handleResponse(res);
        });

        this.menuBar = false;
    }

    saveStock() {
        this.receiptService.saveStock(this.item).then(res => {
            if (res.alert == "info") {
                this.loadList(this.goToFirstLink);
                this.clearAll();
            }

            this.toast.handleResponse(res);
        });

        this.menuBar = false;
    }

    getPaymentMwthod(paymnetList) {
        let method = "";

        if (paymnetList.length == 0) {
            method = "Pay Later";
        } else if (paymnetList.length == 1) {
            method = paymnetList[0].paymentType;
        } else if (paymnetList.length > 1) {
            method = "Split";
        }

        return method;
    }
    voidReceipt() {
        this.receiptService.voidStock(this.item).then(res => {
            if (res.alert == "info") {
                this.loadList(this.goToFirstLink);
                this.clearAll();
            }

            this.toast.handleResponse(res);
        });

        this.menuBar = false;
    }

    clearAll() {
        this.paymentList = [];

        this.item = {
            id: 0,
            profileID: 0,
            selectedProfile: "",
            type: "",
            status: ""
        };
    }

    updatePreviewStatus() {
        this.receiptID = 0;
        this.previewPosReceipt = false;
    }

    previewDialog() {
        this.receiptID = this.item.id;
        this.previewPosReceipt = true;
        this.menuBar = false;
    }

    printReceipt(){
        this.receiptService
            .getTreceiptdata(this.item.id, 2)// 2 means Remaining Payment
            .then((res) => {
                this.generatePosReceipt(res);
            });
    }

    generatePosReceipt(res){
    if (res.original.htmlTemplate) {
                // Open a new window and write the HTML content to it
                const printWindow = window.open('', '_blank');
                if (printWindow !== null) {
                    printWindow.document.open();
                    printWindow.document.write(`
                        <html>
                            <head>
                                <title>Print Receipt</title>
                            </head>
                            <body onload="setTimeout(function() { window.print(); window.close(); }, 300)">
                                ${res.original.htmlTemplate} <!-- HTML content from the response -->
                            </body>
                        </html>
                    `);
                    printWindow.document.close(); // Close the document
                    // printWindow.focus(); // Focus on the new window
                    // printWindow.print(); // Trigger the print dialog
                    // printWindow.close(); // Close the window after printing
                }
            }
    }

    get totalPaidCash() {
        let total = 0;

        this.paymentList.forEach(e => {
            if (e.paymentType == "Cash") {
                total = total + e.transTotalAmount;
            }
        });

        return total;
    }

    get totalPaidBank() {
        let total = 0;

        this.paymentList.forEach(e => {
            if (e.paymentType != "Cash") {
                total = total + e.transTotalAmount;
            }
        });

        return total;
    }

    setAccountingEntries() {
        this.counterEntry = [];

        let totalPaid = this.totalPaidCash + this.totalPaidBank;

        if (totalPaid > 0) {
            if (
                this.item.type == "INE" ||
                this.item.type == "TRN" ||
                this.item.type == "RPU"
            ) {
                if (this.totalPaidCash > 0) {
                    this.counterEntry.push({
                        accountID: 2,
                        accountHead: "Cash in hand",
                        amount: this.totalPaidCash,
                        type: "Debit"
                    });
                }

                if (this.totalPaidBank > 0) {
                    this.counterEntry.push({
                        accountID: 8,
                        accountHead: "Cash at bank",
                        amount: this.totalPaidBank,
                        type: "Debit"
                    });
                }

                this.counterEntry.push({
                    accountID: 4,
                    accountHead: "Accounts receivable",
                    amount: totalPaid,
                    type: "Credit"
                });
            } else if (this.item.type == "RFD" || this.item.type == "PUR") {
                this.counterEntry.push({
                    accountID: 5,
                    accountHead: "Accounts payable",
                    amount: totalPaid,
                    type: "Debit"
                });

                if (this.totalPaidCash > 0) {
                    this.counterEntry.push({
                        accountID: 2,
                        accountHead: "Cash in hand",
                        amount: this.totalPaidCash,
                        type: "Credit"
                    });
                }

                if (this.totalPaidBank > 0) {
                    this.counterEntry.push({
                        accountID: 8,
                        accountHead: "Cash at bank",
                        amount: this.totalPaidBank,
                        type: "Credit"
                    });
                }
            } else {
                //TRANSFER ENTRY YET NEEDS TO BE DONE
            }
        }
    }

    get currency() {
        return this.store.getters.getCurrency;
    }


    calculateTotalAmount() {
        this.totalAmountAllRecords =0;
        for (const item of this.lists as any[]) {

            this.totalAmountAllRecords += Number(item.total_bill);

        }
    }

    calculateTotalBalance() {
        this.totalBalanceAllRecords = 0;
        ////console.log("calculate total  balance")
        for (const item of this.lists as any[]) {
            this.totalBalanceAllRecords += this.calculateBalance(item.total_bill, item.receipt_balance);

        }
    }

    
}
